export default "__VITE_ASSET__DdOqmjwc__"